import React, { useState, useEffect } from 'react';
import { Button } from '@lifepal/lifepal-design-system';

import PostList from '../PostList/PostList';
import ArticleLoader from '../ArticleLoader/ArticleLoader';
import ArticleBanner from '../Banners/ArticleBanner/ArticleBanner';
import styles from './ArticlePosts.module.scss';

import { HTTPClient } from '../../lib/api';
import { GTM_CLASS } from '../../lib/constant';
import { IPost, IPageInfo, IPosts, IInArticleBanners } from '../../lib/types';

interface IProps {
  posts: IPosts;
  category?: string;
  keyword?: string;
  authorName?: string;
  tag?: string;
  emptyMessage?: string;
  inArticleBanners?: IInArticleBanners[];
}

const ArticlePosts = ({
  posts,
  category,
  keyword,
  authorName,
  tag,
  emptyMessage,
  inArticleBanners,
}: IProps) => {
  const [articleList, setArticleList] = useState<{ node: IPost }[]>([]);
  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    endCursor: '',
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: '',
  });
  const [isFetchingList, setFetchingList] = useState(false);
  const BANNER_PER_ARTICLE = 4;
  let counter = 0;

  const fetchMoreList = async () => {
    setFetchingList(true);

    setTimeout(() => {
      const firsLoader = document.getElementById('loader_0');
      if (firsLoader) window.scrollTo({ top: firsLoader.offsetTop, behavior: 'smooth' });
    }, 100);

    const URL = '/media/api/cms/posts/';
    const req = {
      body: JSON.stringify({
        first: 20,
        after: pageInfo.endCursor,
        ...(category && { category }),
        ...(keyword && { keyword }),
        ...(authorName && { authorName }),
        ...(tag && { tag }),
      }),
      method: 'POST',
    };

    const articlePosts = await HTTPClient(URL, req);

    setFetchingList(false);
    if (articlePosts.posts) {
      if (articlePosts.posts.pageInfo) setPageInfo(articlePosts.posts.pageInfo);
      if (articlePosts.posts.edges && articlePosts.posts.edges.length) {
        const combinedList = [...articleList, ...articlePosts.posts.edges];
        setArticleList(combinedList);
      }
    }
  };

  useEffect(() => {
    if (posts) {
      if (posts.pageInfo) setPageInfo(posts.pageInfo);
      if (posts.edges && posts.edges.length) setArticleList(posts.edges);
    }
  }, [posts]);

  const showInarticleBanner = (articleIdxPos) => {
    let articleIdx = articleIdxPos / BANNER_PER_ARTICLE;
    articleIdx = Math.round(articleIdx % inArticleBanners.length);
    articleIdx -= 1;
    return (
      <div className={styles['article__posts--banner']}>
        <ArticleBanner
          data={inArticleBanners[articleIdx]}
          categorySlug={category}
          type={inArticleBanners[articleIdx].type}
        />
      </div>
    );
  };

  return (
    <div className={styles.article__posts}>
      {articleList.length ? (
        articleList.map((article, index) => {
          const post = article.node;
          if (counter === 3 && inArticleBanners && inArticleBanners.length > 0) {
            counter = 0;
            return (
              <div key={post.slug}>
                <PostList post={post} />
                {showInarticleBanner(index)}
              </div>
            );
          }

          counter++;
          return <PostList post={post} key={post.slug} />;
        })
      ) : (
        <div>{emptyMessage || 'Artikel tidak ditemukan'}</div>
      )}
      {isFetchingList && [...new Array(10)].map((_, i) => <ArticleLoader key={i} index={i} />)}
      {pageInfo && Object.keys(pageInfo).length && (
        <div className={styles['article__posts--footer']}>
          {pageInfo.hasNextPage && (
            <Button
              variant="ghost"
              size="lg"
              onClick={fetchMoreList}
              isBlock
              isLoading={isFetchingList}
              loaderColor="#1D66DD"
              className={GTM_CLASS.VIEW_MORE_ARTICLE}
            >
              Lihat Lebih Banyak
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default ArticlePosts;
